import { RouterModule, Routes } from '@angular/router';
import { ReportingListComponent } from './reporting-list/reporting-list.component';
import { BookingOfficeReportingListComponent } from "./bo-reporting-list/bo-reporting-list.component";

const reportRoutes: Routes = [
	{
		path: 'reporting',
		component: ReportingListComponent,
	},
	{
		path: 'bo-reporting',
		component: BookingOfficeReportingListComponent,
	},
];

export const reportingRouting = RouterModule.forChild(reportRoutes);



// WEBPACK FOOTER //
// ./src/app/components/reporting/reporting.routing.ts